"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorage = {
    setItem: function (key, value) { return isSupported() && window.sessionStorage.setItem(key, JSON.stringify(value)); },
    getItem: function (key) { return (isSupported() ? JSON.parse(window.sessionStorage.getItem(key)) : null); },
    removeItem: function (key) { return isSupported() && window.sessionStorage.removeItem(key); }
};
var isSupported = function () {
    try {
        var key = 'random-key6';
        window.sessionStorage.setItem(key, key);
        window.sessionStorage.removeItem(key);
        return true;
    }
    catch (e) {
        return false;
    }
};
